import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import Icon from 'components/global/Icon';
import Tag from 'components/global/Tag';
import Typography from 'components/global/Typography';

import useAxiosPrivate from 'hooks/useAxiosPrivate';
import useUpdateEffect from 'hooks/useUpdateEffect';

import { ADDRESS } from 'services/consts';

import { faChevronRight } from '@fortawesome/pro-light-svg-icons';

import EnumSelect from './EnumSelect';
import * as S from './styled/ComplexCityComponent.styled';

const ComplexCityComponent = (props) => {
	const { countryName, setValue } = props;

	const axios = useAxiosPrivate();
	const { t } = useTranslation();

	const [fetchedCountryName, setFetchedCountryName] = useState();
	const [recommendedCities, setRecommendedCities] = useState();
	const [showNoItems, setShowNoItems] = useState(false);

	useUpdateEffect(() => {
		if (countryName !== fetchedCountryName) {
			setFetchedCountryName();
			setRecommendedCities();
		}
	}, [countryName]);

	const getTranslatedValue = (prefix, value) => {
		if (prefix) {
			const valueWithPrefix = `${prefix}${value}`;
			const translatedValueWithPrefix = t(valueWithPrefix);
			if (translatedValueWithPrefix !== valueWithPrefix) {
				return translatedValueWithPrefix;
			}
			return t(value);
		}

		return value;
	};

	return (
		<EnumSelect
			fetchFunction={async (searchValue) => {
				setShowNoItems(searchValue && searchValue?.length > 1);

				if (!searchValue && countryName !== fetchedCountryName) {
					try {
						const response = await axios.post(ADDRESS.GET_CITIES_BY_COUNTRY_WITH_KEYWORD, {
							country: countryName
						});
						setFetchedCountryName(countryName);
						setRecommendedCities(response.data.data);
					} catch {
						// do nothing
					}

					return [];
				} else if (!searchValue || searchValue?.length < 2) {
					return [];
				} else {
					const response = await axios.post(ADDRESS.GET_CITIES_BY_COUNTRY_WITH_KEYWORD, {
						country: countryName,
						keyword: searchValue
					});
					return response.data.data;
				}
			}}
			renderOption={(option) => (
				<S.ItemContainer>
					{option.stateName && (
						<>
							<Typography color="var(--content-3)" fontWeight="500">
								{getTranslatedValue('state.', option.stateName)}
							</Typography>
							<Icon icon={faChevronRight} color="var(--content-3)" />
						</>
					)}
					{option.governorateName && (
						<>
							<Typography color="var(--content-3)" fontWeight="500">
								{getTranslatedValue('governorate.', option.governorateName)}
							</Typography>
							<Icon icon={faChevronRight} color="var(--content-3)" />
						</>
					)}
					{option.name && (
						<Typography fontWeight="500">{getTranslatedValue('city.', option.name)}</Typography>
					)}
				</S.ItemContainer>
			)}
			reFetchOnSearch
			noItemsPlaceholder={showNoItems ? undefined : 'typeAtLeast2Characters'}
			emptyStateComponent={
				recommendedCities &&
				fetchedCountryName === countryName &&
				((closePopper) => (
					<S.RecommendedContainer>
						<Typography fontWeight="500" color="var(--content-3)">
							recommendedCities
						</Typography>
						<S.RecommendedItemContainer>
							{recommendedCities.map((city) => (
								<Tag
									key={city.id}
									label={city.name}
									onClick={() => {
										setValue(city);
										closePopper();
									}}
								/>
							))}
						</S.RecommendedItemContainer>
					</S.RecommendedContainer>
				))
			}
			searchInputPlaceholder="complexCityComponent.searchCityName"
			{...props}
		/>
	);
};

export default ComplexCityComponent;
